module.exports = __webpack_public_path__ + "img/shortblackarrow.68ccf0a2.svg";